export enum EventType {
  SPREADSHEET_ACTIVE_CELL_CHANGED = 'SPREADSHEET_ACTIVE_CELL_CHANGED',
  WORKBOARD_VALUATION_UPDATED = 'WORKBOARD_VALUATION_UPDATED',
  FIN_MAP_ATT_MAPPER_UPDATED_VIA_GEN_JOB_COMPLETED = 'FIN_MAP_ATT_MAPPER_UPDATED_VIA_GEN_JOB_COMPLETED',
  NAVIGATE_TO_DOCUMENT_REFERENCE = 'NAVIGATE_TO_DOCUMENT_REFERENCE',
  VALUATION_NOTE_CHANGED = 'VALUATION_NOTE_CHANGED',
}

export interface ValuationNoteChangedPayload {
  valuationId: string;
  latestNote: { id: number; content: string } | null;
}

export interface NavigateToDocumentReferencePayload {
  documentReferenceId: number;
  sheetName?: string;
}

export type EventSubscriber<T = any> = (payload: T) => void;

export interface EventSubscription {
  id: string;
  eventType: EventType;
  callback: EventSubscriber;
}

export interface EventBusContextType {
  // any because payload can literally be anything
  subscribe: (eventType: EventType, callback: any) => () => void;
  publish: (eventType: EventType, payload: any) => void;
  unsubscribe: (subscriptionId: string) => void;
  getSubscribers: (eventType: EventType) => EventSubscription[];
}

